<template>
  <div class='flex'>
    <div class='hidden sm:block w-1/2 h-dvh overflow-hidden'>
      <div ref='globeRef' />
      <!-- <img src='@/assets/artwork/login.jpg' class='w-full h-full object-cover' /> -->
    </div>
    <div class='w-full sm:w-1/2 h-dvh p-4 bg-jananavy-900 flex'>
      <div class='m-auto'>
        <div class='p-6 sm:p-8 bg-white rounded-md shadow-sm max-w-[30rem]'>
          <div class='flex justify-center items-center gap-4'>
            <img class='h-6 md:h-8' src='@/assets/artwork/jana-logo-blue.svg' alt='Steward' />
            <img class='h-6 md:h-8' src='@/assets/artwork/platform-logo-blue.svg' alt='Steward' />
          </div>
          <!-- <p class='mt-6 text-center'>Steward is a digital tool for ESG, lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> -->
          <a :href='`${config.auth0LoginUrl}?returnTo=${redirect}`' class="mt-6 text-center block rounded-md bg-jananavy-900 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-jananavy-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-jananavy-800">Sign in</a>
          <p class='text-xs mt-6 -mb-2'>By clicking ‘sign in’ you agree to accept the <a :href='config.legalDocumentationUrl' target='_blank' rel='noopener' class='underline'>terms and conditions</a>.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import Globe from 'globe.gl';
import * as THREE from 'three';

import earthBlueMarble from '@/assets/globe/earth-blue-marble.jpg';
import earthTopology from '@/assets/globe/earth-topology.png';
import clouds from '@/assets/globe/clouds.png';

import { computed, onMounted, ref } from 'vue';
import { config } from '@/kernel/config';

const props = defineProps({
  redirect: String
});

const redirect = computed(() => {
  if (!props.redirect) {
    return '/';
  }

  const url = new URL(props.redirect, window.location.href);

  if (url.origin !== window.location.origin) {
    return '/';
  }

  return props.redirect;
});

const globeRef = ref();

onMounted(() => {
  const world = new Globe(globeRef.value, { animateIn: false })
    .globeImageUrl(earthBlueMarble)
    .bumpImageUrl(earthTopology);

  world.controls().autoRotate = true;
  world.controls().autoRotateSpeed = 0.35;

  const CLOUDS_IMG_URL = clouds;
  const CLOUDS_ALT = 0.004;
  const CLOUDS_ROTATION_SPEED = -0.006; // deg/frame

  new THREE.TextureLoader().load(CLOUDS_IMG_URL, cloudsTexture => {
    const clouds = new THREE.Mesh(
      new THREE.SphereGeometry(world.getGlobeRadius() * (1 + CLOUDS_ALT), 75, 75),
      new THREE.MeshPhongMaterial({ map: cloudsTexture, transparent: true })
    );

    world.scene().add(clouds);

    (function rotateClouds() {
      clouds.rotation.y += CLOUDS_ROTATION_SPEED * Math.PI / 180;
      requestAnimationFrame(rotateClouds);
    })();
  });

  setTimeout(() => {
    resize();
  }, 100);

  window.addEventListener('resize',  () => {
    resize();
  });

  const resize = () => {
    const sizes = {};

    sizes.width = window.innerWidth/2
    sizes.height = window.innerHeight

    // Update camera
    world.camera().aspect = sizes.width / sizes.height
    world.camera().updateProjectionMatrix()

    // Update renderer
    world.renderer().setSize(sizes.width, sizes.height);
    world.renderer().setPixelRatio(Math.min(window.devicePixelRatio, 2));
  }
});

</script>
